export type IconSize = "mini" | "small" | "medium" | "large"

export const IconSizes: Record<IconSize, string> = {
    mini: "28px",
    small: "32px",
    medium: "40px",
    large: "48px"
}